
    import {
      getAllStudentRequirements,
      createStudentRequirement,
      createAllStudentRequirements,
      updateStudentRequirement,
      deleteStudentRequirement
    } from "@/services/studentRequirement";

    const state = {
      studentRequirements: [],
      processed: false
    };

    const getters = {
      getStudentRequirements(state) {
        return state.studentRequirements;
      },
      studentRequirementProcessed(state){
        return state.processed;
      }
    };

    const actions = {
      fetchStudentRequirements({ commit }, params) {
          commit("SET_PROCESSING");
          return new Promise((resolve, reject) => {
            getAllStudentRequirements(
              params
            )
              .then(response => {
                commit("SET_STUDENTREQUIREMENTS", response.data);
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        },
        createStudentRequirement({ commit }, studentRequirement) {
          return new Promise((resolve, reject) => {
            createStudentRequirement(studentRequirement)
              .then(response => {
                commit("SET_PROCESSED");
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        },
        createAllStudentRequirements({ commit }, studentRequirements) {
          return new Promise((resolve, reject) => {
            createAllStudentRequirements(studentRequirements)
              .then(response => {
                commit("SET_PROCESSED");
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        },
        updateStudentRequirement({ commit }, studentRequirement) {
          return new Promise((resolve, reject) => {
            updateStudentRequirement(studentRequirement)
              .then(response => {
                commit("SET_PROCESSED");
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        },
        deleteStudentRequirement({ commit }, id) {
          return new Promise((resolve, reject) => {
            deleteStudentRequirement(id)
              .then(response => {
                commit("SET_PROCESSED");
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        }
      };

    const mutations = {
      SET_STUDENTREQUIREMENTS(state, data) {
        state.studentRequirements = data;
        state.processed = true;
      },
      SET_PROCESSING(state) {
        state.processed = false;
      },
      SET_PROCESSED(state) {
        state.processed = true;
      }
    };

    export default {
      state,
      getters,
      actions,
      mutations
    };
    